import Symbol from './Symbol';
import SymbolMap from './SymbolMap';
import { DEFAULT_SYMBOL_MAP } from '@/pages/dsst-spick/dsstConfig';

interface GuideScreenProps {
  onStart: () => void;
  setIndex: number;
}

const EXAMPLE_SYMBOL = 0; // 첫 번째 기호
const EXAMPLE_NUMBER = DEFAULT_SYMBOL_MAP[EXAMPLE_SYMBOL]; // 1

// 게임 소개 (스픽 스타일)
// - 공통 구조: 태그 → 게임명 → 설명 → 대응표/예시 카드 → 게임 시작하기
export default function GuideScreen({ onStart, setIndex }: GuideScreenProps) {
  return (
    <div className="relative flex flex-col h-full bg-white px-6 animate-fade-in-up overflow-hidden">
      <div className="relative flex-1 min-h-0 overflow-y-auto flex flex-col">
        <div className="m-auto w-full flex flex-col items-center">
          <div className="relative flex flex-col items-center text-center">
            <span className="relative inline-flex items-center h-8 px-4 rounded-full bg-primary-50 text-primary-600 text-[14px] font-bold whitespace-nowrap">
              #집중력
            </span>

            <h1 className="relative text-[28px] font-bold text-foreground-950 leading-tight tracking-tight mt-4 text-center">
              기호 맞추기
            </h1>
          </div>

          <p className="text-[15px] leading-relaxed text-foreground-600 mt-3 text-center">
            45초 동안 기호와 짝이 되는 숫자를
            <br />
            최대한 많이 맞춰주세요.
          </p>

          {/* 대응표 + 예시: 기호만 보고 숫자를 고르는 방식을 한 번에 보여준다 */}
          <div className="mt-8 w-full rounded-[28px] bg-background-50 border border-background-200 px-5 py-9">
            <SymbolMap
              symbolMap={DEFAULT_SYMBOL_MAP}
              setIndex={setIndex}
              symbolSizeClass="w-11 h-11"
            />
            <div className="mt-10 flex items-center justify-center gap-6">
              <div className="w-[104px] h-[104px] flex items-center justify-center text-accent-500">
                <Symbol symbolId={EXAMPLE_SYMBOL} setIndex={setIndex} className="w-[104px] h-[104px]" />
              </div>
              <i className="ri-arrow-right-line text-foreground-300 text-3xl leading-none" />
              <div className="sh-example-tile rounded-[18px] w-[80px] h-[80px] text-foreground-900 flex items-center justify-center text-3xl font-bold">
                {EXAMPLE_NUMBER}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative shrink-0 pt-4 pb-[calc(20px+env(safe-area-inset-bottom))]">
        <button
          onClick={onStart}
          className="w-full h-14 rounded-xl sh-cta text-white font-semibold text-base whitespace-nowrap
            active:scale-[0.99] transition-transform duration-150 cursor-pointer"
        >
          게임 시작하기
        </button>
      </div>
    </div>
  );
}